import { render, staticRenderFns } from "./DetalleAnuncio.vue?vue&type=template&id=5968ef54"
import script from "./DetalleAnuncio.vue?vue&type=script&lang=js"
export * from "./DetalleAnuncio.vue?vue&type=script&lang=js"
import style0 from "./DetalleAnuncio.vue?vue&type=style&index=0&id=5968ef54&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports